import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import {
  enableProdMode,
  provideZoneChangeDetection
} from '@angular/core';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from './environments/environment.local';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideRouter(APP_ROUTES),
    provideAnimations(),
    provideHttpClient(),
]
}).catch(err => console.error(err));
